import styled from "styled-components"
import { AosWrapper } from "../../molecules/AosWrapper"
import { Button } from "../../atoms"
import { useRouter } from "next/router"
import { TextField } from "@project/shared"
import { IVacancy } from "../../../utils/interfaces/vacancy"

const Wrapper = styled.div`
  width: 100%;
  padding: 100px;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.footerSectionColor};

  @media (max-width: 641px) {
    padding: 50px 20px;
  }
`

export const Heading = styled.h2`
  font-weight: 600;
  font-size: 30px;
  line-height: 150%;
  color: #fff;
  text-align: center;

  @media (max-width: 910px) {
    font-size: 22px;
  }
`

const GradientSpan = styled.span`
  background: linear-gradient(
    87.75deg,
    #0058ee 0%,
    rgba(54, 215, 183, 0.8) 100%
  );
  /* stylelint-disable property-no-vendor-prefix */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* stylelint-enable property-no-vendor-prefix */
  background-clip: text;
  font-weight: 600;
  font-size: 30px;
  line-height: 150%;
  @media (max-width: 910px) {
    font-size: 22px;
  }
`

export const SubHeading = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 170%;
  letter-spacing: 0%;
  text-align: center;
  color: #ffffffcc;
  white-space: pre-wrap;
  margin-top: 16px;

  @media (max-width: 910px) {
    font-size: 14px;
    white-space: normal;
  }
`
export const Section = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 910px) {
    margin-top: 20px;
    gap: 12px;
  }
`
export const Card = styled.div`
  padding-top: 60px;
  padding-right: 30px;
  padding-bottom: 60px;
  padding-left: 30px;
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  position: relative;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.41), rgba(0, 0, 0, 0.41))
      padding-box,
    linear-gradient(
        148deg,
        #2c3651 38.91%,
        #18223f 72.14%,
        rgba(13, 109, 98, 0) 178.47%
      )
      padding-box,
    linear-gradient(87.75deg, #0058ee 0%, rgba(54, 215, 183, 0.8) 100%)
      border-box;

  border-bottom: 1px solid transparent;

  @media (max-width: 910px) {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .image {
    width: 72px;
    height: 72px;

    @media (max-width: 910px) {
      width: 40px;
      height: 40px;
    }
    @media (max-width: 375px) {
      width: 30px;
      height: 30px;
    }
  }
  @media (max-width: 375px) {
    padding: 20px;
    border-radius: 12px;
    border-bottom-width: 1px;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 554px;

  /* @media (max-width: 768px) {
    width: 100%;
  } */
`
export const Title = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 170%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #f5f5f5;

  @media (max-width: 910px) {
    font-size: 16px;
    display: none;
  }
`

export const ImgContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  .title {
    display: none;
    @media (max-width: 910px) {
      display: block;
      font-weight: 600;
      font-size: 22px;
      line-height: 170%;
      letter-spacing: 0%;
      vertical-align: middle;
      color: #f5f5f5;
    }
  }
`

export const Description = styled.div`
  width: 100%;
  .icon {
    width: 24px;
    height: 24px;

    @media (max-width: 910px) {
      width: 20px;
      height: 20px;
    }
  }

  .tech-row {
    display: flex;
    width: 100%;
    gap: 40px;

    @media (max-width: 910px) {
      flex-direction: column;
      gap: 8px;
    }
  }

  .content {
    display: flex;
    gap: 6px;
    align-items: center;
    color: #ffffffcc;
  }

  .position {
    font-weight: 400;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0%;
    color: #ffffffcc;

    @media (max-width: 910px) {
      font-size: 14px;
    }
  }
  .title {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0%;
    color: #fff;
    @media (max-width: 910px) {
      font-size: 14px;
    }
  }
`
const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 40px;

  button {
    text-transform: uppercase;
  }
  @media (max-width: 910px) {
    margin-left: 0px;
    button {
      height: 38px;
    }
  }
  @media (max-width: 910px) {
    width: 100%;
    button {
      width: 100%;
      text-transform: uppercase;
    }
  }
`

const InputFieldWrapper = styled.div`
  margin-bottom: 20px;
  background: #202534;
  & .text-area {
    width: 100%;
    .ant-input-affix-wrapper {
      background-color: transparent;
    }
    .ant-input {
      padding: 25px 15px 0px 15px;
      background-color: transparent;
      font-size: 1rem;
      @media (max-width: 500px) {
        font-size: 0.875rem;
      }
    }
  }
  & .text-field {
    width: 100%;
    height: 50px;
    background: #202534;

    .ant-input-affix-wrapper {
      background-color: transparent;
    }
    .ant-input {
      background-color: transparent;
      font-size: 1rem;
      font-family: "Inter", sans-serif;
      height: 50px;
      margin-left: 10px;
      color: #ffffff99;

      @media (max-width: 500px) {
        height: 38px;
        padding: 12px;
        font-size: 0.875rem;
        margin-left: 0px;
      }
    }
  }
`
export const Image = styled.img`
  width: 28px;
  height: 20px;

  @media (max-width: 768px) {
    width: 20px;
    height: 20px;
  }
`

const mockData = [
  {
    imgSrc: "/assets/imgs/work-case.svg",
    title: "Software Engineer",
    description: [{ title: "Mid Level", workType: "Fully Remote" }],
    url: "#",
  },
  {
    imgSrc: "/assets/imgs/work-case.svg",
    title: "UI/UX Designer",
    description: [{ title: "Mid Level", workType: "Fully Remote" }],
    url: "#",
  },
  {
    imgSrc: "/assets/imgs/work-case.svg",
    title: "Flutter Developer",
    description: [{ title: "Mid Level", workType: "Fully Remote" }],
    url: "#",
  },
  {
    imgSrc: "/assets/imgs/work-case.svg",
    title: "QA Engineer",
    description: [{ title: "Mid Level", workType: "Fully Remote" }],
    url: "#",
  },
  {
    imgSrc: "/assets/imgs/work-case.svg",
    title: "PHP Developer",
    description: [{ title: "Mid Level", workType: "Fully Remote" }],
    url: "#",
  },
]
interface IVacancyprops {
  vacancyData: IVacancy[]
}

const WeAreHiring: React.FC<IVacancyprops> = ({ vacancyData }) => {
  const router = useRouter()
  return (
    <Wrapper>
      <AosWrapper>
        <Heading>
          {"We're"} <GradientSpan>hiring</GradientSpan> :{" "}
          <GradientSpan>Join</GradientSpan> our dynamic team !
        </Heading>
        <SubHeading>
          {
            "RTW Happy hours: unwinding and bonding after work, socializing and making \nteam bond stronger"
          }
        </SubHeading>
        <Section>
          <InputFieldWrapper>
            <TextField
              name={"full_name"}
              className={"text-field"}
              borderradius={"6px"}
              // value={""}
              // onChange={""}
              placeholder={"Search for a job"}
              prefix={
                <Image src={"/assets/imgs/search-alt.svg"} alt="Search" />
              }
              bgcolor={"#202534 !important"}
              bordercolor={"#313952 !important"}
            />
          </InputFieldWrapper>
          {(vacancyData.length ? vacancyData : mockData).map((item, index) => (
            <Card key={index}>
              <ImgContent>
                <img
                  src={item.imgSrc}
                  alt={`we-are-hiring-${index}`}
                  className="image"
                />
                <p className={"title"}>{item.title}</p>
              </ImgContent>
              <Content>
                <Title>{item.title}</Title>
                <Description>
                  {item.description.map((item, index) => {
                    return (
                      <div className={"tech-row"} key={index}>
                        <div className="content">
                          <img
                            src={"/assets/imgs/suitcase.svg"}
                            alt={`we-are-hiring-${index}`}
                            className="icon"
                          />
                          <p className={"position"}>{"Position"}</p>
                          <p className="title">{item?.title}</p>
                        </div>
                        <div className="content">
                          <img
                            src={"/assets/imgs/laptop.svg"}
                            alt={`we-are-hiring-${index}`}
                            className="icon"
                          />
                          <p className={"position"}>{item?.workType}</p>
                        </div>
                      </div>
                    )
                  })}
                </Description>
              </Content>
              <ButtonWrapper>
                <Button
                  width={"172px"}
                  buttonType={"secondary"}
                  onClick={() => router.push(item?.url)}
                >
                  {"View details"}
                </Button>
              </ButtonWrapper>
            </Card>
          ))}
        </Section>
      </AosWrapper>
    </Wrapper>
  )
}

export { WeAreHiring }
